import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { CandidateMeetingModel, DeclineInterviewRequest } from "../../../interviews.models";
import { InterviewStatus } from "../../../interviews.enums";

@Component({
    selector: 'decline-interview-widget',
    templateUrl: './decline-interview-widget.component.html',
    standalone: false
})
export class DeclineInterviewWidgetComponent implements OnChanges {
  @Input() meeting?: CandidateMeetingModel;

  @Output() onDeclineInterviewClicked: EventEmitter<DeclineInterviewRequest> = new EventEmitter();

  declineInterview: boolean = false;
  declineNotes: string = '';
  disableDeclineButton: boolean = false;

  public InterviewStatus = InterviewStatus;

  ngOnChanges(changes: SimpleChanges): void {
    this.declineInterview = false;
    this.declineNotes = '';
    this.disableDeclineButton = false;
  }

  public declineNotesChange(event: Event){
    const value = (event.target as HTMLInputElement).value;
    this.declineNotes = value;
  }

  public clickDeclineInterview(meeting: CandidateMeetingModel): void {
    this.disableDeclineButton = true;
    let request: DeclineInterviewRequest = { meeting: meeting, declineNotes: this.declineNotes };
    this.onDeclineInterviewClicked.emit(request);
  }
}
